<template>
    <div class="bodyApp" style="background:	#0F172A">
        <div class="f_img">
            <img :src="img1" alt="" style="margin-bottom:17px;margin-top:13px;width:100%;">
        </div>
        <div class="from_data">
            <div class="f_data" id="formData">
                <div class="f_title">限时特惠入口</div>
                <van-swipe class="my-swipe" :autoplay="5000" vertical :loop="true" :height="36" :show-indicators="false">
                    <van-swipe-item>曾** 已领取 1分钟前 <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>李** 正在领取 1分钟前 <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>张** 已领取 1分钟前 <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>赵** 已领取 1分钟前 <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>钱** 正在领取 1分钟前 <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>孙** 已领取 1分钟前 <span>已有18379人申请</span></van-swipe-item>
                </van-swipe>
                <van-cell-group>
                    <van-field v-model="dataFrom.takeNickname" clearable label="姓名" placeholder="请输入收货人姓名" />
                    <van-field v-model="dataFrom.takePhone" maxlength="11" clearable label="联系号码" placeholder="请输入联系号码" />

                    <van-field v-model="dataFrom.pcaAddress" clearable label="省市区" placeholder="请选择省市区" readonly
                        @focus="showAddressVisible()" />
                    <van-field v-model="dataFrom.takeAddress" clearable label="详细地址" placeholder="请输入收货详细地址" />
                </van-cell-group>
                <van-popup v-model="dataFrom.addressVisible" position="bottom">
                    <van-area :area-list="areaList" :columns-placeholder="['请选择', '请选择', '请选择']"
                        @cancel="cancelSelectAddress()" @confirm="selectAddress" />
                </van-popup>
                <van-field name="stepper" label="购买数量" required>
                    <template #input>
                        <van-stepper v-model="dataFrom.iccidSize" @change="onChange" />
                    </template>
                </van-field>
                <van-button round type="info" class="btnButton" @click="sunmbitFn()">支付{{ dataFrom.price }}元
                    包邮到家</van-button>
            </div>
        </div>
        <div class="f-swige">
            <div class="f_new">热门评论</div>
            <van-swipe class="my-swipe" vertical :autoplay="5000" :loop="true" :height="70" :show-indicators="false">
                <van-swipe-item>
                    <div class="jusaf">
                        <van-row>
                            <van-col span="4">
                                <img src="@/assets/stage/icon17.png" alt="" />
                            </van-col>
                            <van-col span="20">
                                <div style="color:#000;height:20px;line-height: 20px;">
                                    <van-row>
                                        <van-col span="12"> 盈**牛 </van-col>
                                        <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                    </van-row>
                                </div>
                                <div style="color: rgb(153, 153, 153);line-height: 20px;">网速杠杠的，费用美美的</div>
                            </van-col>
                        </van-row>
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="jusaf">
                        <van-row>
                            <van-col span="4">
                                <img src="@/assets/stage/icon17.png" alt="" />
                            </van-col>
                            <van-col span="20">
                                <div style="color:#000;height:20px;line-height: 20px;">
                                    <van-row>
                                        <van-col span="12">罗**</van-col>
                                        <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                    </van-row>
                                </div>
                                <div style="color: rgb(153, 153, 153);line-height: 20px;">还便宜，网速还很快</div>
                            </van-col>
                        </van-row>
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="jusaf">
                        <van-row>
                            <van-col span="4">
                                <img src="@/assets/stage/icon17.png" alt="" />
                            </van-col>
                            <van-col span="20">
                                <div style="color:#000;height:20px;line-height: 20px;">
                                    <van-row>
                                        <van-col span="12">离**歌</van-col>
                                        <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                    </van-row>
                                </div>
                                <div style="color: rgb(153, 153, 153);line-height: 20px;">不错......很划算</div>
                            </van-col>
                        </van-row>
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="jusaf">
                        <van-row>
                            <van-col span="4">
                                <img src="@/assets/stage/icon17.png" alt="" />
                            </van-col>
                            <van-col span="20">
                                <div style="color:#000;height:20px;line-height: 20px;">
                                    <van-row>
                                        <van-col span="12">辣**果</van-col>
                                        <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                    </van-row>
                                </div>
                                <div style="color: rgb(153, 153, 153);line-height: 20px;">好实惠的手机套餐，经济适用。</div>
                            </van-col>
                        </van-row>
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="jusaf">
                        <van-row>
                            <van-col span="4">
                                <img src="@/assets/stage/icon17.png" alt="" />
                            </van-col>
                            <van-col span="20">
                                <div style="color:#000;height:20px;line-height: 20px;">
                                    <van-row>
                                        <van-col span="12">王**森</van-col>
                                        <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                    </van-row>
                                </div>
                                <div style="color: rgb(153, 153, 153);line-height: 20px;">手机卡到的很快,激活顺利,套餐价格优惠,满意.</div>
                            </van-col>
                        </van-row>
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="jusaf">
                        <van-row>
                            <van-col span="4">
                                <img src="@/assets/stage/icon17.png" alt="" />
                            </van-col>
                            <van-col span="20">
                                <div style="color:#000;height:20px;line-height: 20px;">
                                    <van-row>
                                        <van-col span="12">严**</van-col>
                                        <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                    </van-row>
                                </div>
                                <div style="color: rgb(153, 153, 153);line-height: 20px;">很好，到达时间快，业务员上门服务，便宜优惠</div>
                            </van-col>
                        </van-row>
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="jusaf">
                        <van-row>
                            <van-col span="4">
                                <img src="@/assets/stage/icon17.png" alt="" />
                            </van-col>
                            <van-col span="20">
                                <div style="color:#000;height:20px;line-height: 20px;">
                                    <van-row>
                                        <van-col span="12">莹**子</van-col>
                                        <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                    </van-row>
                                </div>
                                <div style="color: rgb(153, 153, 153);line-height: 20px;">好实惠的手机套餐，经济适用。</div>
                            </van-col>
                        </van-row>
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="jusaf">
                        <van-row>
                            <van-col span="4">
                                <img src="@/assets/stage/icon17.png" alt="" />
                            </van-col>
                            <van-col span="20">
                                <div style="color:#000;height:20px;line-height: 20px;">
                                    <van-row>
                                        <van-col span="12">毛**九</van-col>
                                        <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                    </van-row>
                                </div>
                                <div style="color: rgb(153, 153, 153);line-height: 20px;">网速杠杠的，费用美美的</div>
                            </van-col>
                        </van-row>
                    </div>
                </van-swipe-item>
            </van-swipe>
        </div>

        <div class="f_img">
            <img :src="img2" alt="" style="margin-bottom:38px;width:100%;">
        </div>








        <div class="chColor" v-if="isShow" @click="changeTab">支付{{ dataFrom.price }}元 包邮到家</div>
    </div>
</template>

<script>
import areaListData from "@/utils/Area.js";
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant';
export default {
    data() {
        return {
            isFirst: 0,
            smsCode: '',
            smsFlag: false,
            btnTxt: '获取验证码',
            time: 3 * 60 * 60 * 1000,
            dataFrom: {
                oldIccid: this.$store.state.iccid,
                takeNickname: '',
                id: '',
                price: '',
                agentId: '',
                addressVisible: false,
                changeCmccSimName: "",
                takePhone: '',
                takeAddress: '',
                changeCmccSim: '1',
                pcaAddress: '',
                iccidSize: '1',
                wxCode: "",
            },
            checked: false,
            isShow: false,
            areaList: areaListData,

            img1: '',
            img2: '',
        }
    },
    mounted() {
        // 滚动条的获取
        window.addEventListener('scroll', this.handleScrollx, true)
    },
    async created() {
        var appid = process.env.VUE_APP_APPID;
        localStorage.setItem("appid", appid);
        this.$store.commit("setIsHeadquarterAppid", "true");
        localStorage.setItem("isHeadquarterAppid", true);

        var redirectUrl = window.location.href;
        var index = redirectUrl.indexOf("code");
        redirectUrl = encodeURIComponent(redirectUrl);
        if (index < 0) {
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
        } else {
            var search = window.location.search;
            var startIndex = search.indexOf("code");
            var endIndex = search.indexOf("&", startIndex);
            var str = search.slice(startIndex, endIndex);
            var code = str.slice(str.indexOf("=") + 1);
            this.dataFrom.wxCode = code;
           
        }
        this.dataFrom.id = this.$route.query.id;
        this.dataFrom.agentId = this.$route.query.agentId;
        this.dataFrom.changeCmccSimName = this.$route.query.changeCmccSimName;
        this.img1 = process.env.VUE_APP_IMG_URL + "/" + this.$route.query.img;
        if (this.$route.query.imgInfo) {
            this.img2 = process.env.VUE_APP_IMG_URL + "/" + this.$route.query.imgInfo;
        }
        this.getPrice();
    },
    destroyed() { //离开这个界面之后，删除滚动事件，不然容易除bug
        window.removeEventListener('scroll', this.handleScrollx)
    },
    methods: {
        //获取价格
        getPrice() {
            let data = {
                id: this.dataFrom.id,
            };
            wxRequest("applyChangeSim/buy/agent/price", data, "post").then((res) => {
                if (res.data.code == 200) {
                    this.dataFrom.price = res.data.data.price / 100;
                }
            });
        },

        //步进器改变执行
        onChange(val) {
            this.dataFrom.iccidSize = val;
            this.dataFrom.price = this.userInfo.iccidSize * this.userInfo.perprice;
        },
        getSmsCode() {
            var data = {
                userPhone: this.dataFrom.takePhone
            }
            wxRequest("bindPhone/sms/code/auth", data, "post").then(res => {
                if (res.data.code == 200) {
                    var n = 60;
                    this.btnTxt = '重新发送' + n + 's';
                    let timer = window.setInterval(() => {
                        n--;
                        this.btnTxt = '重新发送' + n + 's';
                        if (n < 1) {
                            window.clearInterval(timer);
                            this.btnTxt = '获取验证码';
                        }
                    }, 1000)
                    Toast.success("发送成功");
                } else {
                    Dialog.alert({ title: "提示", message: res.data.message });
                }
            })
        },
        handleScrollx() {
            if (window.pageYOffset >= 600) {
                this.isShow = true
            } else {
                this.isShow = false
            }
        },
        changeTab() {
            document.getElementById('formData').scrollIntoView({
                block: 'center',
                behavior: 'smooth' // 代表平滑滚动
            });
        },
        cancelSelectAddress() {
            this.dataFrom.pcaAddress = "";
            this.dataFrom.addressVisible = false;
        },
        showAddressVisible() {
            this.dataFrom.addressVisible = true;
        },
        selectAddress(values) {
            if (!values[0].code || values[0].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[1].code || values[1].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[2].code || values[2].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (
                values[0].code == "110000" ||
                values[0].code == "120000" ||
                values[0].code == "310000" ||
                values[0].code == "500000"
            ) {
                this.dataFrom.pcaAddress = values[0].name + '-' + values[2].name;
            } else {
                this.dataFrom.pcaAddress = values[0].name + '-' + values[1].name + '-' + values[2].name;
            }
            this.dataFrom.addressVisible = false;
        },
        // 提交数据
        sunmbitFn() {
            if (
                this.dataFrom.takeNickname == "" ||
                this.dataFrom.takePhone == "" ||
                this.dataFrom.takeAddress == "" ||
                this.dataFrom.pcaAddress == "" ||
                this.dataFrom.changeCmccSimName == ""
            ) {
                Dialog.alert({ title: "提示", message: "请确保信息完整正确" });
                return;
            }
            if (
                this.dataFrom.takePhone &&
                !/^[1][3,4,5,6,7,8][0-9]{9}$/.test(this.dataFrom.takePhone)
            ) {
                Dialog.alert({ title: "提示", message: "请填写正确的手机号" });
                return;
            }
            let data = JSON.parse(JSON.stringify(this.dataFrom));
            const formData = new FormData();
            Object.keys(data).forEach((key) => {
                formData.append(key, data[key]);
            });
            formData.append("isAgent", 0);
            formData.append("changeCmccSim", 4);
            wxRequest("order/buy/sim", formData, "post").then((res) => {
                if (res.data.code == 200) {
                    if (this.leShuaPay == true) {
                        window.location.href = res.data.data.jspay_url;
                    } else {
                        let param = res.data.data.param;
                        WeixinJSBridge.invoke(
                            "getBrandWCPayRequest",
                            param,
                            function (res) {
                                if (res.err_msg == "get_brand_wcpay_request:ok") {
                                    Dialog.alert({
                                        title: "提示",
                                        message: "购买成功！预计24小时发货 请耐心等候",
                                    });
                                }
                            }
                        );
                    }
                } else {
                    Dialog.alert({ title: "提示", message: res.data.message });
                }
            });
        },
    }
}
</script>
<style lang="less" scoped>
.f_img {
    text-align: center;
}

.chColor {
    width: 90%;
    height: 44px;
    color: #fff;
    text-align: center;
    line-height: 44px;
    border-radius: 24.5px;
    font-size: 23px;
    position: fixed;
    bottom: 20px;
    z-index: 100;
    left: 0;
    margin-left: 5%;
    background: -webkit-linear-gradient(to right, #FEAC37, #FD7324);
    /* Safari 5.1-6.0 */
    background: -o-linear-gradient(to right, #FEAC37, #FD7324);
    /* Opera 11.1-12.0 */
    background: -moz-linear-gradient(to right, #FEAC37, #FD7324);
    /* Firefox 3.6-15 */
    background: linear-gradient(to right, #FEAC37, #FD7324);
    /* 标准语法 */
    border: 1px solid #FD7324;
    border-image: -webkit-linear-gradient(to right, #FEAC37, #FD7324);
    /* Safari 5.1-6.0 */
    border-image: -o-linear-gradient(to right, #FEAC37, #FD7324);
    /* Opera 11.1-12.0 */
    border-image: -moz-linear-gradient(to right, #FEAC37, #FD7324);
    /* Firefox 3.6-15 */
    border-image: linear-gradient(to right, #FEAC37, #FD7324);
    /* 标准语法 */
}

.chColor {
    -webkit-animation: free_download1 1s linear alternate infinite;
    animation: free_download1 1s linear alternate infinite;
}

@-webkit-keyframes free_download1 {
    0% {
        -webkit-transform: scale(0.9);
    }

    100% {
        -webkit-transform: scale(1);
    }
}

@keyframes free_download1 {
    0% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}

.from_data {
    margin: 0 14px;
    background: #fff;
    padding: 9px;
    border-radius: 10px;

    .f_data {
        border-radius: 10px;
        border: 1px dashed #FD7C27;

        .f_title {
            height: 42px;
            line-height: 42px;
            width: 208px;
            background: url(../../assets/title.png) no-repeat center;
            background-size: 100% 100%;
            font-size: 20px;
            color: #fff;
            text-align: center;
            margin: -21px auto 0 auto;
        }

        .my-swipe {
            height: 35px;
            line-height: 35px;
            background: #787B81;
            border-radius: 6px;
            width: 82%;
            margin: 13px auto;
            color: #fff;
            padding: 0 12px;

            span {
                display: inline-block;
                padding-left: 16px;
            }
        }

        .checkbox-info {
            width: 85%;
            margin: 10px auto;
            font-size: 12px;

            .van-checkbox {
                display: inline-block;
                margin-top: 4px;
            }
        }

        .btnButton {
            width: 93%;
            margin: 10px auto;
            display: block;
            background: -webkit-linear-gradient(to right, #FEAC37, #FD7324);
            /* Safari 5.1-6.0 */
            background: -o-linear-gradient(to right, #FEAC37, #FD7324);
            /* Opera 11.1-12.0 */
            background: -moz-linear-gradient(to right, #FEAC37, #FD7324);
            /* Firefox 3.6-15 */
            background: linear-gradient(to right, #FEAC37, #FD7324);
            /* 标准语法 */
            border: 1px solid #FD7324;
            border-image: -webkit-linear-gradient(to right, #FEAC37, #FD7324);
            /* Safari 5.1-6.0 */
            border-image: -o-linear-gradient(to right, #FEAC37, #FD7324);
            /* Opera 11.1-12.0 */
            border-image: -moz-linear-gradient(to right, #FEAC37, #FD7324);
            /* Firefox 3.6-15 */
            border-image: linear-gradient(to right, #FEAC37, #FD7324);
            /* 标准语法 */
            cursor: pointer;
            font-size: 18px;
        }

        .btnButton {
            -webkit-animation: free_download 1s linear alternate infinite;
            animation: free_download 1s linear alternate infinite;
        }

        @-webkit-keyframes free_download {
            0% {
                -webkit-transform: scale(0.9);
            }

            100% {
                -webkit-transform: scale(1);
            }
        }

        @keyframes free_download {
            0% {
                transform: scale(0.9);
            }

            100% {
                transform: scale(1);
            }
        }
    }
}

.f-swige {
    margin: 10px 14px;
    background: #fff;
    padding: 9px;
    border-radius: 10px;
    height: 250px;
    overflow: hidden;

    .f_new {
        font-size: 18px;
        padding: 14px 0 15px 12px;
        font-weight: 600;
    }

    .jusaf {
        img {
            width: 52px;
            height: 52px;
        }
    }
}

.f-tbottm {
    width: 100%;
    margin-top: 17px;
    padding-bottom: 26px;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
    color: #fff;
}
</style>